module.exports = __webpack_public_path__ + "static/media/coffee.6b32a64d.jpg";